import type { PrivateEventCrewView } from '../../api/privateEvents';

import NotRecordedPill from './NotRecordedPill';

export default function EventNotes({ event }: { event: PrivateEventCrewView }) {
  if (event.notes) {
    return (
      <span
        style={{
          fontSize: 12.5,
          lineHeight: 1.55,
          color: 'var(--nb-ink-2)',
          whiteSpace: 'pre-wrap',
        }}
      >
        {event.notes}
      </span>
    );
  }
  return event.migrated ? (
    <NotRecordedPill field="Notes" short />
  ) : (
    <span style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>None</span>
  );
}
